import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styles: [
  ]
})
export class HeaderComponent implements OnInit {
  datos:any;
  cargo:string;
  plantel:string;
  Nombre:string;
  Correo:string;

  inicioSesion:any;
  finSesion:any;

  countdownTimer:any;
  minutes:any;
  remainingSeconds:any;

  constructor(private router:Router) {
    this.datos=JSON.parse(localStorage.getItem('datos')!);
    this.cargo=this.datos.cargodb;
    this.plantel=this.datos.plantel;
    this.Nombre=this.datos.nom;
    this.Correo=this.datos.correop;


   }

  ngOnInit(): void {


    this.inicioSesion=localStorage.getItem('inicioSesion');
    this.finSesion=localStorage.getItem('finSesion');
    // console.log(this.inicioSesion);
    // console.log(this.finSesion);

    

  }

ngAfterViewInit(): void {
  this.secondPassed(); 
}


  secondPassed() {

var seconds= 7200;

// Calcula la fecha de finalización del contador sumando
// el número de segundos a la fecha actual
var end = (new Date()).getTime() + seconds * 1000;
displayCounter();
var timeout = setInterval(displayCounter, 300);

function displayCounter(){
  // Calcula el número de segundos que faltan para llegar a la fecha de finalización
  var counter = Math.floor((end - (new Date()).getTime()) / 1000);
  if (counter < 0) counter = 0;
  
  document.getElementById('countdown').innerHTML = ': '+
      Math.floor(counter / 60) + ':' +
      ('00' + Math.floor(counter % 60)).slice(-2)

      // console.log(Math.floor(counter / 60) + ':' +
      // ('00' + Math.floor(counter % 60)).slice(-2));
      
  if (counter === 0) {
    clearTimeout(timeout);
    console.log("¡Tiempo Agotado !");
  }
  
}


 } 

}
